// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__Pk2Vp","spin":"styles_spin__8x4oh"};